export const parseSectionFiltersFromSearchParams = (sectionFilters: string | null): string[] => {
  if (!sectionFilters) {
    return [];
  }

  return sectionFilters
    .split(",")
    .map((section) => section.trim())
    .filter((section) => section.length > 0)
    .map((section) => {
      return "/" + section.replace(/ > /g, "/");
    });
};
